(function () {
  var TEST_ID = '019e072f-09fa-7493-a9bb-8bb632cdd2b5';

  // Helper — entscheidet welche Variante aktiv ist
  function isTreatmentForced() {
    return new URLSearchParams(location.search).get('cart') === 'v2';
  }

  // (1) V1 oder V2 entfernen statt nur hiden — KEIN ID-Doppel mehr
  function applyHardSwitch(showTreatment) {
    var control = document.querySelector('[data-cart-variant="control"]');
    var treatment = document.querySelector('[data-cart-variant="treatment"]');
    if (!control || !treatment) return;
    if (showTreatment) {
      control.remove();      // ← statt display:none
      treatment.style.display = '';
    } else {
      treatment.remove();    // ← entferne V2 wenn Control gewinnt
      control.style.display = '';
    }
  }

  // (2) Bei JEDEM Cart-Re-render erneut anwenden
  function watchAndReapply(showTreatment) {
    applyHardSwitch(showTreatment);
    var container = document.getElementById('ajax-loading-cart');
    if (container) {
      new MutationObserver(function () {
        applyHardSwitch(showTreatment);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  // Force-Override für Devs
  if (isTreatmentForced()) {
    watchAndReapply(true);
    return;
  }

  // Normaler Shoplift-Flow
  function onShopliftReady(cb, max) {
    max = max || 50;
    var n = 0;
    (function tick() {
      if (window.shoplift) return cb(window.shoplift);
      if (++n < max) setTimeout(tick, 100);
    })();
  }

  async function applyVariant() {
    onShopliftReady(async function (shoplift) {
      try {
        var isTreatment = await shoplift.isHypothesisActive(TEST_ID);
        watchAndReapply(isTreatment);   // ← einmalig + auto-reapply nach Re-render
      } catch (e) { /* fallback: Control */ }
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#cart-icon, button[name="add"], [data-cart-open], [aria-label*="cart" i]');
    if (trigger) applyVariant();
  }, { capture: true });

  document.addEventListener('alpine:initialized', function () {
    if (window.Alpine && Alpine.store && Alpine.store('xMiniCart')) {
      var store = Alpine.store('xMiniCart');
      var origOpen = store.openCart && store.openCart.bind(store);
      if (origOpen) {
        store.openCart = function () {
          applyVariant();
          return origOpen.apply(this, arguments);
        };
      }
    }
  });
})();